exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-55d35a97] {\n  height: 42px;\n  border-radius: 4px;\n}\ntfoot tr td[data-v-55d35a97] {\n  font-weight: bold;\n}\n", ""]);

// exports
